import { Action, createAction, props } from "@ngrx/store";
import { LoanApplication } from '@data/schema/loan-appication/loan-application';

export const loadLoanApplication = createAction(
  "[LoanApplication List] Load Loan Application"
);
export const loadLoanApplicationSuccess = createAction(
  "[Loan Application List] Load Loan Application Success",
  props<{ loanApplications: LoanApplication[] }>()
);
export const loadLoanApplicationError = createAction(
  "[Photo List] Load Loan Application Error",
  props<{ isError: boolean }>()
);

export const updateLoanApplication = createAction(
  "[Photo List] Like Photo",
  props<{ loanApplication: LoanApplication }>()
);
export const updateLoanApplicationSuccess = createAction(
  "[Loan Application List] Update Loan Application Success",
  props<{ loanApplication: LoanApplication }>()
);
export const updateLoanApplicationError = createAction(
  "[Photo List] Update Loan Application Error"
);

export const loadLoanApplicationById = createAction(
  "[Loan Application] Load Loan Application By Id",
  props<{ id: string }>()
);
export const loadLoanApplicationByIdSuccess = createAction(
  "[Loan Application List] Load Loan Application By Id",
  props<{ loanApplications: LoanApplication }>()
);
export const loadLoanApplicationByIdError = createAction(
  "[Loan Application] Load Loan Application By Id Error"
);

export const createLoanApplication = createAction(
  "[LoanApplication List] Create Loan Application",
  props<{ loanApplication: LoanApplication }>()
);
export const createLoanApplicationSuccess = createAction(
  "[Loan Application List] Create Loan Application Success",
  props<{ loanApplication: LoanApplication }>()
);
export const createLoanApplicationError = createAction(
  "[Photo List] Create Loan Application Error"

);

export const createLoanApplicationByXML = createAction(
  "[LoanApplication List] Create Loan Application By XML",
  props<{ loanApplication: FormData }>()
);
export const createLoanApplicationByXMLSuccess = createAction(
  "[Loan Application List] Create Loan Application By XML Success",
  props<{ loanApplication: LoanApplication }>()
);
export const createLoanApplicationByXMLError = createAction(
  "[Photo List] Create Loan Application By XML Error"

);
